"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var contexts_1 = require("../../contexts");
var MasterContext_1 = __importDefault(require("../../contexts/MasterContext"));
var FormatText_1 = __importDefault(require("../FormatText"));
var CrudCreate = function (props) {
    var onCreate = props.onCreate, children = props.children;
    var crudState = react_1.useMemo(function () { return ({
        selectedItem: undefined,
        isCreate: true,
        isUpdate: false,
    }); }, []);
    var masterState = react_1.useMemo(function () {
        return {
            selectedItem: undefined,
            handleSubmit: function (value) {
                if (onCreate)
                    onCreate(value);
            },
        };
    }, [onCreate]);
    return (react_1.default.createElement(MasterContext_1.default.Provider, { value: masterState },
        react_1.default.createElement(contexts_1.CrudContext.Provider, { value: crudState },
            react_1.default.createElement(antd_1.Card, { className: "ant-app-details-area", title: react_1.default.createElement(FormatText_1.default, { id: "ui.commons.new", uppercase: true }) }, children))));
};
exports.default = CrudCreate;
